import React, { Component } from 'react';
import { ContractSideBar, Header } from '../../Elements';
import RentalCard from '../components/RentalCard';
import ClosingBalanceDetails from '../components/ClosingBalanceDetails';
import { Button, CircularProgress, Paper } from '@material-ui/core';
import { globalExportService, globalGetService } from '../../../../globalServices';
import { checkApiStatus, checkPermission, downloadFileType } from '../../../../utils_v2';
import ReserveCard from '../components/ReserveCard';
import InfiniteScroll from 'react-infinite-scroll-component';
import SecurityCard from '../components/SecurityCard';
import { STableLoader } from '../../../../shared_elements/loaders';
import { assetsType } from '../../../../constants';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { sExportContractsAc } from '../../../../shared/actionCreators';
import { ExportManu, PageLoader } from '../../../../shared_elements';
import { NoRecordFound } from '../../../../shared';
import { exportContractCashflowAc, loadCashFlowAssetViewAc } from '../../CashFlows/actionCreators';
import { contrResvRateListAc } from '../../MRRates/actionCreators';

class CashflowAccurals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cashFlowData: {},
      isLoading: false,
      pageLoader:false
    };
  }

  componentDidMount() {
    this.getCashFlowDetails({ page: 1, per_page: 10 });
    this.props.fetchAssetInfo();
  }

  changeMsn = (evt) => {
    const url = '/' + assetsType[evt.asset_type] + '/' + evt.slug + '/contracts';
    browserHistory.push(url);
  }

  getCashFlowDetails = (query) => {
    this.setState({ isLoading: true });
    globalGetService(`contracts/${this.props?.params?.contract_slug}/cash-receivable/`, query)
      .then((response) => {
        this.setState({ isLoading: false });

        if (checkApiStatus(response)) {
          const responseData = response.data.data;
          if (query?.page === 1) {
            this.setState({ cashFlowData: responseData });
          } else {
            this.setState((prevState) => ({
              cashFlowData: {
                ...prevState.cashFlowData,
                list: [...(prevState.cashFlowData.list || []), ...responseData.list],
                pagination: responseData.pagination,
              }
            }));
          }
        } else {
          this.props.enqueueSnackbar(response?.data?.message, {  variant: 'error',  anchorOrigin: { vertical: 'top', horizontal: 'right' },});
        }
      });
  }

  moveNextPage = () => {
    const { cashFlowData } = this.state;
    const query = {
      page: (cashFlowData?.pagination?.page || 1) + 1,
      per_page: 10
    };
    this.getCashFlowDetails(query);
  }

  render() {
    const { cashFlowData, isLoading, pageLoader } = this.state;
    const { params, exportContract, cashflowLoader } = this.props;
    console.log('this.props',this.props);
    
    return (
      <section className="lease-management-section">
        <div className="mr-rate-wrapper  mr-rate-spacing" style={{marginTop:'80px'}}>
          <Header
            type="brief"
            headingText="Lease Management"
            params={params}
            changeMsn={this.changeMsn}
            exportContract={exportContract}
          />
          <ContractSideBar
            application="Cashflow v1"
            type="brief"
            params={params}
          />
          <div className="cshflw-container" style={{ background: 'none' }}>
            {/* {checkPermission('contracts','cash_receivables','EXP') && cashFlowData?.list?.length  ?
            <div style={{textAlign:'right', marginRight:'20px', marginBottom:"10px"}}>
            <ExportManu title="Export" files={[{title:'Excel', extension: 'xls', key:''}]} exportReportFn={(file) => this.exportCashFlow(file.extension)} />
            </div>: null} */}
            {isLoading && <STableLoader count={4} />}
            {this.props?.contractSummaryLoader || cashflowLoader || pageLoader? <PageLoader /> :null}
            {cashFlowData?.list?.length > 0 && (
              <InfiniteScroll
                dataLength={cashFlowData.list.length}
                next={this.moveNextPage}
                hasMore={
                  cashFlowData.list.length <
                  (cashFlowData.pagination?.total || 0)
                }
                loader={
                  <h4 style={{ clear: 'both', textAlign: 'center', padding: '10px' }}>
                    <CircularProgress size={20} style={{ marginRight: '10px' }} />
                  </h4>
                }
                endMessage={
                  <p style={{ clear: 'both', textAlign: 'center', padding: '10px' }}>
                    Yay! You have seen it all
                  </p>
                }
              >
                {cashFlowData.list.map((item, index) => (
                  <Paper style={{ marginBottom: '20px', padding: '20px' }} key={index}>
                    <div className='head-wrapper'>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h5>CLOSING BALANCE</h5>
                        <h4>Period: <b style={{ display: 'contents' }}>{item.for_month}</b></h4>
                      </div>
                      <ClosingBalanceDetails data={item.closing_balance} />
                    </div>

                    {item?.rental?.items?.length > 0 && <RentalCard data={item.rental} params={params}/>}
                    {item?.reserve?.items?.length > 0 && <ReserveCard data={item.reserve} params={params} />}
                    {item?.security_deposit?.items?.length > 0 && <SecurityCard data={item.security_deposit} params={params} />}
                  </Paper>
                ))}
              </InfiniteScroll>
            )}
            { cashFlowData?.list?.length || isLoading ? null: <NoRecordFound /> }
          </div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => ({
  contractSummaryLoader:state.sharedReducers.contractSummaryLoader,
  cashflowLoader: state.ContrCashFlowReducer.cashflowLoader,
  ctrShortInfo: state.ContractListReducer.ctrShortInfo,
});
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAssetInfo: () => dispatch(loadCashFlowAssetViewAc(ownProps.params)),
    exportCashFlow: (contract, fileType, filter) => dispatch(exportContractCashflowAc(ownProps, contract, fileType, filter)),
    exportContract : (contract_slug) => dispatch(sExportContractsAc(contract_slug))
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CashflowAccurals));
